import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import AppraisersSummary from '../../../appraisals/AppraisersSummary';
import ValuationsLanding from '../../../valuations/ValuationsLanding';

export default function ValuationsRoutes() {
    return (
        <>
            <Route
                path='/valuations/appraisers'
                element={
                    <RequireAdmin>
                        <AppraisersSummary />
                    </RequireAdmin>
                }
            />
            <Route
                path='/valuations'
                element={
                    <RequireAdmin>
                        <ValuationsLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
